import { UserCircleIcon } from '@synoptic/ui-kit/icons/react/user-circle.tsx';
import { HTMLAttributes } from 'react';
import { useLocation } from 'react-router';
import { getRedirectLink } from '@/routes-utils/get-redirect-link.ts';
import { paths } from '@/routes-utils/paths.ts';
import { MenuActionLink } from './menu-action-link.tsx';

export const GuestAuthMenuAction = ({
  className,
}: HTMLAttributes<HTMLElement>) => {
  const location = useLocation();

  return (
    <MenuActionLink
      className={className}
      icon={<UserCircleIcon />}
      label="Log in"
      to={getRedirectLink(paths.login, location.pathname)}
    />
  );
};
